import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {

    componentDidMount() {
        var that = this;
        setTimeout(
             function() {
                 that.applies().then((gdpr_applies) => {
                     if (gdpr_applies) {
                         $('.footer-tarot-links').addClass('change');
                     }
                 });
             }, 5000); // TODO: move to saga
    }

    render() {
        return (
            <gdpr-cmp-sortable>
                <li class='sortable-consent' style='display:none'>
                    <a onClick={(e) => this.handleOpenCMP(e)}>
                        Your Privacy Settings
                    </a>
                </li>
            </gdpr-cmp-sortable>
        );
    }

    applies() {
        return new Promise(function(resolve) {
            try {
                window.__cmp('getConsentData', null, function(d) {
                    resolve(d.gdprApplies);
                });
            } catch(error) {
                resolve(false); // Pages without ads
            }
        });
    }

    handleOpenCMP(e) {
        e.preventDefault();
        e.stopPropagation();
        window.deployads.showConsentTool();
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/gdpr-cmp-sortable.js